/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {authenticateInstitution} from '../api'

export const useMutationAuthenticateInstitution = createReactQueryMutationHook('authenticateInstitution', authenticateInstitution)
